import React, { useState } from "react"
import styled, { css } from "styled-components"
import {
    Facebook,
    Instagram,
} from "./footerSocials"
import {
    Input,
    Button,
    theme
} from "@omnichannel/ace-b2b-elements"
import { WebView, MobileView } from "../styles/common"
import { useStaticQuery, graphql, navigate} from "gatsby"

const Main = styled.div`
  background-color: #fff;
  width: 100%;
`

const FooterContainer = styled.div`
  margin: 0 auto;
  max-width: 120rem;
  padding: 4rem;
  @media screen and (max-width: 768px) {
    padding: 4rem 3rem;
  }
`

const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 768px) {
    padding-top: 1rem;
    flex-direction: row;
    align-items: flex-start;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) =>
        props.centered &&
        css`
      align-items: center;
    `}
`
const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

const HorizontalSpacer = styled.div`
  height: 1.5rem;
  ${(props) =>
        props.mobileView &&
        css`
      height: 0;
      @media screen and (max-width: 768px) {
        height: 4rem;
      }
    `}
`

const VerticalSpacer = styled.div`
  width: 1rem;
`

const FooterCell = styled.div`
  width: 100%;
  @media (min-width: 960px) {
    padding-left: 2rem;
  }
  @media (min-width: 960px) {
    padding-left: 2rem;
  }
  @media (min-width: 1024px) {
    padding-left: 4rem;
  }
  @media (min-width: 1280px) {
    padding-left: 10rem;
  }
`
0
const FooterCellTitle = styled.div`
  font-weight: 300;
  font-size: 1.4rem;
  color: #272829;
  line-height: 1.3;
  max-width: 100%;
  @media (min-width: 375px) {
      font-size: 1.6rem;
  }
  @media (min-width: 411px) {
      font-size: 1.7rem;
  }
  @media (min-width: 810px) {
      font-size: 1.7rem;
  }
  @media (min-width: 960px) {
      font-size: 2rem;
  }
`

const FooterLink = styled.div`
  color: #272829;
  font-size: 1.3rem;
  cursor: pointer;
  @media (min-width: 768px) {
    font-size: 1.4rem;
  }
`

const FooterCopyright = styled.div`
  font-size: 1.1rem;
  color: #272829;
  line-height: 2.2rem;
  @media (min-width: 768px) {
    font-size: 1.2rem;
  }
`

const Link = styled.a`
  color: rgb(103, 179, 213);
  margin-left: 0.3rem;
`

const ErrorMessage = styled.div`
  margin-top: 0.5rem;
  color: #ffc900;
`



const FooterLinkBox = styled.div`
    display: flex;
    width: 100%;
    max-width: 70rem;
    flex-direction: row;
    flex-wrap: wrap;
    @media (min-width: 768px) {
        flex-wrap: nowrap;
    }
`

const FooterLinkBoxItem = styled.div`
    display: flex;
    color: #272829;
    font-size: 1.6rem;
    text-align: left;
    margin: 0 0 1.4rem 0;
    width: 50%;
    white-space: nowrap;
    cursor: pointer;
`

const FooterDivider = styled.div`
    width: 100%;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #BCBCBC;
`


const FooterCategoryLinkBox = styled(FooterLinkBox)`
    max-width: 100%;
    @media (min-width: 768px) {
        justify-content: flex-start;
        align-items: flex-start;
        align-content: flex-start;
        width: 42%;
        flex-wrap: wrap;
    }
`
const FooterCategoryLinkBoxItem = styled(FooterLinkBoxItem)`
    font-size: 1.3rem;
    text-transform: capitalize;
    margin: 0 0 1rem 0;
    white-space: normal;
    padding-right: .8rem;
    @media (min-width: 768px) {
        font-size: 1.4rem;
    }
`


const FooterCommon = (props) => {
    const { baseUrl, profileUrl, loading, onClickEvent } = props
    const [email, setEmail] = useState("")
    const [checked, setChecked] = useState(true)
    const [error, setError] = useState("")
    const [privacyError, setPrivacyError] = useState(false)

    const data = useStaticQuery(
        graphql`
            query FooterCategoryItem {
                estore {
                    categories {
                        name
                    }
                }
            }
        `)

    const handleSubmit = () => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        setPrivacyError(false)
        if (!checked) {
            setPrivacyError(true)
        }
        if (!email) {
            setError("This field is required")
            return
        } else if (!re.test(String(email).toLowerCase())) {
            setError("Invalid email")
            return
        }
        if (!checked || !email) {
            return
        }
        if (onClickEvent) {
            onClickEvent(email)
        }
        setEmail("")
        setChecked(false)
    }

    const handleChange = (event) => {
        const { value } = event.target
        setEmail(value)
        setError("")
    }

    const handleChangeChecbox = () => {
        setChecked(!checked)
        if (privacyError) {
            setPrivacyError(false)
        }
    }

    const SubscribeContent = (
        <FooterCell>
            <FlexColumn >
                <FooterCellTitle>
                    Join our newsletter and exclusive updates
                            
                        {/* <br />
                    enjoy 20% on your first order. */}
                </FooterCellTitle>
                <div style={{ marginTop: "-0.5rem" }}>
                    <Input
                        style={{
                            background: "#fff",
                            width: "100%",
                            maxWidth: "40rem",
                            borderRadius: "0",
                            border: "none",
                            borderBottom: "1px solid #E0E1E2",
                            paddingLeft: ".4rem",
                        }}
                        placeholder="Your email address"
                        noRightComponentBorder
                        value={email}
                        onChange={handleChange}
                        error={error}
                        rightComponent={
                            <Button
                                style={{
                                    // color: "#BB1F25",
                                    color: theme.default.primary,
                                    fontSize: "1.4rem",
                                    fontWeight: "500",
                                    borderRadius: "0",
                                    width: "10.6rem",
                                    marginLeft: "-0.35rem",
                                    // height: "rem",
                                    transform: "translateY(.1rem)",
                                    border: "none",
                                    borderBottom: "1px solid #E0E1E2",
                                    backgroundColor: '#FFF'
                                }}
                                clickAnimation="highlight"
                                disabled={loading}
                                onClick={handleSubmit}
                                fontSize={"1.4rem"}
                                fontWeight={"500"}
                            >
                                {loading ? "Sending..." : "SIGN ME UP >"}
                            </Button>
                        }
                        rightComponentProps={{
                            width: "auto",
                        }}
                    />
                </div>
                <HorizontalSpacer />
                <FlexRow>
                    <Facebook />
                    <VerticalSpacer style={{ width: "0.5rem" }} />
                    <Instagram />
                </FlexRow>
            </FlexColumn>
        </FooterCell>
    )

    return (
        <Main>
            <MobileView>
                {/* <FooterContainer>
                  {SubscribeContent}
                </FooterContainer>
                <FooterDivider/> */}
            </MobileView>   
            <FooterContainer>
                <FooterLinkBox>
                    <FooterLinkBoxItem onClick={() => navigate(`/static/aboutus`)}>
                        About Us
                    </FooterLinkBoxItem>
                    <FooterLinkBoxItem onClick={() => navigate(`/static/careers`)}>
                        Careers
                    </FooterLinkBoxItem>
                    <FooterLinkBoxItem onClick={() => navigate(`/stores`)}>
                        Store Locator
                    </FooterLinkBoxItem>
                    <FooterLinkBoxItem onClick={() => navigate(`/static/contactus`)}>
                        Contact Us
                    </FooterLinkBoxItem>
                    <FooterLinkBoxItem onClick={() => navigate(`/static/faq`)}>
                        FAQ
                    </FooterLinkBoxItem>
                </FooterLinkBox>
                <HorizontalSpacer style={{ height: "2rem" }} />
                <FooterContent>
                    <FooterCategoryLinkBox>
                        {
                        data.estore.categories.map((category, index) => {
                            return (
                            <FooterCategoryLinkBoxItem key={index} onClick={() => navigate(`/category/${encodeURIComponent(category.name)}`)}> 
                                {category.name.toLowerCase()}
                            </FooterCategoryLinkBoxItem>
                            )
                        })
                        }
                    </FooterCategoryLinkBox>
                    <WebView style={{width: '58%', height:'20rem'}}>
                        <FooterContainer style={{ paddingTop: 0}}>
                        {/* {SubscribeContent} */}
                        </FooterContainer>
                    </WebView>
                </FooterContent>
                <MobileView>
                <HorizontalSpacer style={{ height: "4rem" }} />
                </MobileView>
                <FlexRow>
                    <div>
                        <FooterLink onClick={() => navigate(`/static/privacy`)}>
                            Privacy Policy
                        </FooterLink>
                    </div>
                    <VerticalSpacer />
                    {"|"}
                    <VerticalSpacer />
                    <div>
                        <FooterLink onClick={() => navigate(`/static/termsandcondition`)}>
                            Terms and Conditions
                        </FooterLink>
                    </div>
                </FlexRow>
                <FooterCopyright>
                    © {new Date().getFullYear()} Ace Hardware Philippines. All Rights Reserved.
                </FooterCopyright>
            </FooterContainer>
        </Main >
    )
}

export default FooterCommon
